// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nrkj[data-v-0f401c5e]{position:relative;padding:24px;text-align:center}.s8Sp[data-v-0f401c5e]{display:block}.s8Sp[data-v-0f401c5e]>:first-child{margin-bottom:16px}@media screen and (min-width:1024px){.j9Wq .nrkj[data-v-0f401c5e]{padding:56px}.j9Wq .s8Sp[data-v-0f401c5e]{display:flex}.j9Wq .s8Sp[data-v-0f401c5e]>:first-child{margin-right:16px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp__wrap": "nrkj",
	"comp__buttons": "s8Sp",
	"comp": "j9Wq"
};
module.exports = ___CSS_LOADER_EXPORT___;
